import { createFileRoute } from '@tanstack/react-router';
import AccountUnderReviewLayout from './-layouts/account-under-review-layout';
import { UserState } from '@src/features/user/types/get-profile-response';
import { getProfileQueryOptions } from '@src/features/user/api/get-profile';
import { MyRouterContext } from '@src/app/router';

export const Route = createFileRoute('/account-under-review')({
  component: AccountUnderReviewLayout,
  loader: async ({ context }: { context: MyRouterContext }): Promise<void> => {
    const profile = await context.queryClient.fetchQuery(
      getProfileQueryOptions,
    );

    if (profile?.state === UserState.Approved) {
      window.location.replace('/');
    }
  },
});
